// Handle {{DATE(...)}} and {{TIME(...)}} expressions in text
// These are renderer-side formatting, not part of templating

type DateFormat = 'COMPACT' | 'SHORT' | 'LONG'

function formatDate(isoString: string, format: DateFormat = 'COMPACT'): string {
  const date = new Date(isoString)
  if (isNaN(date.getTime())) return isoString

  const options: Intl.DateTimeFormatOptions = {}
  
  switch (format) {
    case 'LONG':
      options.weekday = 'long'
      options.year = 'numeric'
      options.month = 'long'
      options.day = 'numeric'
      break
    case 'SHORT':
      options.weekday = 'short'
      options.year = 'numeric'
      options.month = 'short'
      options.day = 'numeric'
      break
    case 'COMPACT':
    default:
      options.year = 'numeric'
      options.month = 'short'
      options.day = 'numeric'
      break
  }

  return date.toLocaleDateString(undefined, options)
}

function formatTime(isoString: string): string {
  const date = new Date(isoString)
  if (isNaN(date.getTime())) return isoString

  return date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  })
}

export function processDateTimeExpressions(text: string): string {
  // Match {{DATE(dateString, FORMAT)}} or {{DATE(dateString)}}
  const dateRegex = /\{\{DATE\(([^,)]+)(?:,\s*(COMPACT|SHORT|LONG))?\)\}\}/gi
  
  // Match {{TIME(dateString)}}
  const timeRegex = /\{\{TIME\(([^)]+)\)\}\}/gi

  let result = text
  
  result = result.replace(dateRegex, (_, dateStr, format) => {
    return formatDate(dateStr.trim(), (format?.toUpperCase() as DateFormat) ?? 'COMPACT')
  })
  
  result = result.replace(timeRegex, (_, dateStr) => {
    return formatTime(dateStr.trim())
  })

  return result
}
